
















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop, Watch } from 'vue-property-decorator'
import LimitsTable from '@/components/limits/LimitsTable.vue'
import limitsStore from '@/stores/LimitsStore'
import Limit from '@/dto/limits/Limit'
import { Routes } from '@/router/routes'

@Component({
  components: { LimitsTable },
})
export default class Limits extends Vue {
  @Prop(String)
  limitId: string | null

  limitsStore = limitsStore
  isPending: boolean = false

  get limits(): Limit[] {
    return this.limitsStore.limits
  }

  get isFullSplitter() {
    return this.$route.name === Routes.limits
  }

  created() {
    if (this.limits.length > 0) {
      return
    }

    this.isPending = true
    this.limitsStore.loadLimits().finally(() => (this.isPending = false))
  }

  @Watch('limitId', { immediate: true })
  selectLimit(limitId: string | null) {
    this.limitsStore.selectLimit(limitId ? parseInt(limitId) : null)
  }
}
